import { render, staticRenderFns } from "./coverageAreaListDetail.vue?vue&type=template&id=82173cfa"
import script from "./coverageAreaListDetail.js?vue&type=script&lang=js&external"
export * from "./coverageAreaListDetail.js?vue&type=script&lang=js&external"
import style0 from "./coverageAreaListDetail.vue?vue&type=style&index=0&id=82173cfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports